import { reactive, ref, computed, onMounted, onBeforeMount } from '@vue/composition-api'
import * as _ from 'lodash'
import { PRODUCT_STATUS, PRODUCT_STATUS_NAME } from '@/util/constants'
import { addServiceTemplateTableParams } from '@/logic/common/CommonService'

export const ServiceLicenseCancelInput = (props, context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { contract, contractPack, cancellation } = store.state

  onBeforeMount(() => {
    store
      .dispatch('cancellation/resetAllState')
      .then(() => {
        store.dispatch('contract/getContractData')
        store
          .dispatch('contractPack/getPackageData')
          .then(() => {
            store
              .dispatch('cancellation/setDefaultLists')
              .then(() => {
                state.loaded = true
              })
          })
      })
  })
  
  const signedPackageProduct = computed(() => {
    const list = store.getters['contractPack/signedPackageProduct']

    // 商品リストにテンプレート処理用の追加パラメータを設定
    addServiceTemplateTableParams(list)

    return list
  })

  const cancellationList = computed(() => store.getters['cancellation/getCancelList'])

  const action = reactive({
    selectBoxOnChange: (selected, index) => {
      store.dispatch('cancellation/changeCancellation', { index, selected })
    },
    reset: index => {
      store.dispatch('cancellation/resetCancellation', index)
    },
    allCancel: index => {
      store.dispatch('cancellation/allCancellation', index)
    },
    cancel: index => {
      store
        .dispatch('contractPack/setSelectProduct', cancellation.lists[index])
        .then(() => {
          state.visibleCancelInput = true
        })
    },
    submit: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('cancellation/setCalculation')
        .then(async () => {
          await store.dispatch('cancellation/cancellationConfirm')
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    closeUserInput: () => {
      store.dispatch('cancellation/closeUserInput')
    },
    /**
     * ライセンス管理設定数が次年のライセンス数を超えないように
     * 解除するアカウントのチェックを外すウィンドウで
     * 「設定」ボタンを押した時に呼ばれる
     * @param {*} userToDisable 
     */
    submitUserInput: (userToDisable) => {

      store.dispatch('cancellation/submitUserInput', userToDisable)
      store.dispatch('common/showLoading')
      store
        .dispatch('cancellation/setCalculation')
        .then(async () => {
          await store.dispatch('cancellation/cancellationUserConfirm')
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    closeConfirm: () => {
      store.dispatch('cancellation/closeConfirm')
    },
    submitConfirm: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('cancellation/submitConfirm')
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    closeComplete: () => {
      store
        .dispatch('cancellation/closeComplete')
        .then(() => {
          router.push({ name: 'PCService' })
        })
    }
  })

  const productStatus = index => {
    const thisProduct = cancellation.lists[index]
    const thisCancellation = cancellation.lists[index].cancellation
    const thisEdited = cancellation.lists[index].edited
    const thisBeforeNum = thisProduct.license_number
    const thisAfterNum = thisProduct.license_number - thisCancellation
    const basicProductIndex = _.findIndex(cancellation.lists, product => product.package_name === thisProduct.package_name && product.classification === 2)
    const basicProduct = cancellation.lists[basicProductIndex]
    const basicEdited = cancellation.lists[basicProductIndex].edited
    const basicCancellation = cancellation.lists[basicProductIndex].cancellation
    const basicBeforeNum = basicProduct.license_number
    const basicAfterNum = basicProduct.license_number - basicCancellation
    return {
      isBasic: thisProduct.classification === 2,
      isSigned: PRODUCT_STATUS.SIGNED_PRODUCT.includes(thisProduct.status),
      isSignedAndEdit: PRODUCT_STATUS.SIGNED_PRODUCT.includes(thisProduct.status) && thisEdited,
      isSignedAndNoEdit: PRODUCT_STATUS.SIGNED_PRODUCT.includes(thisProduct.status) && !thisEdited,
      isUnsigned: PRODUCT_STATUS.UNSIGNED_PRODUCT.includes(thisProduct.status),
      isUnsignedAndEdit: PRODUCT_STATUS.UNSIGNED_PRODUCT.includes(thisProduct.status) && thisEdited,
      isUnsignedNoEdit: PRODUCT_STATUS.UNSIGNED_PRODUCT.includes(thisProduct.status) && !thisEdited,
      isEdited: thisEdited,
      isCancel: PRODUCT_STATUS.CANCEL_PRODUCT.includes(thisProduct.status) || thisProduct.cancel_license_number > 0,
      isNothing: PRODUCT_STATUS.UNSIGNED_PRODUCT.includes(thisProduct.status) && !thisEdited,
      beforeNum: thisBeforeNum,
      afterNum: thisAfterNum,
      name: thisProduct.name,
      basicProductIndex: basicProductIndex,
      basicProduct: basicProduct,
      // basicIsCancel: PRODUCT_STATUS.CANCEL_PACKAGE === basicProduct.status || basicProduct.cancel_license_number === basicProduct.license_number,
      basicIsCancel: PRODUCT_STATUS.CANCEL_PACKAGE === basicProduct.status || (basicProduct.license_number > 0 && basicProduct.cancel_license_number === basicProduct.license_number),
      basicIsNothing: PRODUCT_STATUS.UNSIGNED_PRODUCT.includes(basicProduct.status) && !basicEdited,
      basicAfterNum: basicAfterNum,
      basicIsSigned: PRODUCT_STATUS.SIGNED_PRODUCT.includes(basicProduct.status)
    }
  }

  // 各部品の表示
  const visible = reactive({
    // キャンセルのある商品の場合、解除予約の取り消しボタンを表示
    cancel: index => {
      const { isBasic, isCancel, basicIsCancel } = productStatus(index)
      return (isBasic)
        ? isCancel
        : isCancel || basicIsCancel
    },
    parentCancel: index => {
      const { isBasic, isCancel, basicIsCancel } = productStatus(index)
      return (isBasic)
        ? false
        : basicIsCancel
    },
    // ライセンス解除ボタンを表示
    allCancel: index => {
      const { isBasic, isCancel, basicIsCancel, isEdited } = productStatus(index)
      return (isBasic)
        ? !isCancel && !isEdited
        : !basicIsCancel && !isCancel && !isEdited
    },
    // 契約中、かつ、解除予約が入っていない商品、もしくは購入ボタンを押した商品の場合、個数選択のセレクトボックスを表示
    select: index => {
      const { isBasic, isEdited, isSigned, isCancel, basicIsCancel, basicIsNothing, basicAfterNum } = productStatus(index)
      return (isBasic)
        ? !isCancel
        : !isCancel && !basicIsCancel
    },
    // 編集がおこなわれた商品の場合リセットボタンを表示する
    reset: index => {
      const { isEdited } = productStatus(index)
      return isEdited
    },
    note: index => {
      const message = {
        parentCancel: 'パッケージの解約予約に合わせて、自動的に解除予約されています。',
        cancel: '既に解約予約済みです。',
        signed: (param1) => `契約中のライセンス数 ${param1}`,
        edited: (param1, param2) => `契約中のライセンス数 ${param1} > ${param2}`,
        no: ''
      }
      // return productStatus(index)
      return (() => {
        const ps = productStatus(index)
        if (ps.isBasic) {
          // 基本商品
          if (ps.isCancel) return message.cancel
          else if (!ps.isEdited) return message.signed(ps.beforeNum)
          else if (ps.isEdited) return message.edited(ps.beforeNum, ps.afterNum)
          else return message.no
        } else {
          // オプション商品
          if (ps.basicIsCancel) return message.parentCancel
          else if (ps.isCancel) return message.cancel
          else if (!ps.isEdited) return message.signed(ps.beforeNum)
          else if (ps.isEdited) return message.edited(ps.beforeNum, ps.afterNum)
        }
      })()
    }
  })

  const state = reactive({
    loaded: false,
    visibleCancelInput: false,
    visibleServiceInvalidUser: false,
    visibleServiceConfirm: false,
    visibleServiceComplete: false
  })
  const scrollableHeight = ref(0)
  onMounted(() => {
    scrollableHeight.value = window.innerHeight - context.refs.areaScrollable.getBoundingClientRect().top + 84
    context.root.targetScrollFlg = true
  })

  return {
    state,
    scrollableHeight,
    signedPackageProduct,
    PRODUCT_STATUS_NAME,
    cancellation,
    cancellationList,
    contractPack,
    action,
    visible,
    productStatus
  }
}
